import { create } from "zustand";

export type TNotificationType = "chapter_ready" | "chat_responded";

export type TNotification = {
  id: number;
  type: TNotificationType;
  isRead: boolean;
  projectChapterId: number;
  userId: number;
  createdAt: string;
  updatedAt: string;
  projectChapter: {
    id: number;
    projectTemplateChapterSlug: string | null;
    projectId: number;
    project: {
      id: number;
      name: string;
    };
    projectTemplateChapter: {
      name: string;
      slug: string;
    } | null;
  };
};

type TNotificationStore = {
  notifications: TNotification[];

  setNotifications: (notifications: TNotification[]) => void;
  addNotification: (notification: TNotification) => void;
  markChapterAsRead: (chapterId: number) => boolean;
  hasChapterNotification: (chapterId: number) => boolean;
};

export const useNotificationStore = create<TNotificationStore>((set, get) => ({
  notifications: [],

  setNotifications: (notifications: TNotification[]) => {
    set({ notifications });
  },

  addNotification: (notification: TNotification) => {
    set({ notifications: [notification, ...get().notifications] });
  },

  markChapterAsRead: (chapterId: number) => {
    let changedChaptersCounter = 0;
    set({
      notifications: get().notifications.map((n) => {
        if (n.projectChapterId === chapterId) {
          if (!n.isRead) changedChaptersCounter++;
          return { ...n, isRead: true };
        }
        return n;
      })
    });
    return changedChaptersCounter > 0;
  },

  hasChapterNotification: (chapterId: number) => {
    return Boolean(get().notifications.find((n) => n.projectChapterId === chapterId && !n.isRead));
  }
}));
